import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import ConfirmationModal from "@/components/DailyReportUpdateModalParts/IgnoreLongTimelongContinuousWarningConfirmationModal.vue";
import UpdateModal from "@/components/DailyReportUpdateModalParts/IgnoreLongTimelongContinuousWarningUpdateModal.vue";
import { Ref, ref, computed, watch } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'IgnoreLongTimelongContinuousWarning',
  props: {
    modelValue: { type: Boolean },
    deliveryPlanId: {},
    createAuthority: { type: Boolean },
    showFlash: { type: Function }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const modelValue = computed(() => {
  return props.modelValue;
})

watch(() => props.modelValue,
() => {
  confirmModalState.value = props.modelValue;
})

const confirmModalState:Ref<boolean> = ref(modelValue.value)
const updateModalState:Ref<boolean> = ref(false)

function confirm() {
  confirmModalState.value = false
  updateModalState.value = true
}

function closeModal() {
  emits('update:modelValue', false)
  confirmModalState.value = false
  updateModalState.value = false
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ConfirmationModal, {
      modelValue: confirmModalState.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((confirmModalState).value = $event)),
      onConfirm: confirm,
      onCancel: closeModal
    }, null, 8, ["modelValue"]),
    (updateModalState.value)
      ? (_openBlock(), _createBlock(UpdateModal, {
          key: 0,
          modelValue: updateModalState.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((updateModalState).value = $event)),
          onConfirm: confirm,
          onCancel: closeModal,
          deliveryPlanId: props.deliveryPlanId,
          createAuthority: props.createAuthority,
          showFlash: props.showFlash
        }, null, 8, ["modelValue", "deliveryPlanId", "createAuthority", "showFlash"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})